// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React from 'react'
import PropTypes from 'prop-types'
import { Mutation } from 'react-apollo'

import {
  Input,
  Button,
  Heading,
  KeyValueTable as InputTable,
  EmployerSelect
} from '../../'

import { MUTATION_DIVISION } from '../../../mutations'


export class DivisionAdd extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  state = {
    identityExistsAlready: false,
    employer: '',
    division: '',
    notes: null
  }

  validateInput = (field, value) => {
    if (field === 'identityValue') {
      return value && value.includes('/')
    }

    return true
  }

  requiredInputProvided = () => (
    !!this.state.employer &&
    !!this.state.division
  )

  save = (divisionMutate) => {
    let input = {
      employer: this.state.employer,
      name: this.state.division
    }

    if (this.state.notes) {
      input.notes = this.state.notes
    }

    divisionMutate({ variables: { input }})
    .then(this.props.onSuccess)
    .catch(error => console.error('there was an error saving the identity', error))
  }

  handleInputValueChange = (e) => {
    let field = e.target.id
    this.setState({ [field]: e.target.value })
  }

  getInputForm = () => (
    {
      '*Employer': <EmployerSelect
        id='employer'
        placeholder='Choose employer'
        value={this.state.employer}
        onChange={this.handleInputValueChange}
      />,
      '*Division': <Input
        id='division'
        placeholder='Enter division name'
        value={this.state.division || ''}
        onChange={this.handleInputValueChange}
      />,
      'Notes': <Input
        id='notes'
        placeholder='Enter notes (if any)'
        value={this.state.notes}
        onChange={this.handleInputValueChange}
      />
    }
  )

  render() {
    return (
      <div className={this.props.className}>
        {this.props.title &&
          <Heading className='slds-text-align_center'>
            {this.props.title}
          </Heading>
        }
        <InputTable
          data={this.getInputForm()}
          keyColumnSize='1-of-2'
        />
        <div className='slds-m-top_large slds-clearfix'>
          <div className='slds-text-align_center'>
            <Button
              onClick={this.props.onCancel}
              minWidth={120}
              className='u-text-caps'>
              Cancel
            </Button>
            <Mutation mutation={MUTATION_DIVISION}>
              {(divisionMutate, { data }) => (
                <Button
                  type='brand'
                  onClick={() => this.save(divisionMutate)}
                  disabled={!this.requiredInputProvided()}
                  minWidth={120}
                  className='u-text-caps'>
                  Save
                </Button>
              )}
            </Mutation>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/messageplus/division-add/index.js